module.exports = __webpack_public_path__ + "img/guzheng_20210901113930.a61a5e41.png";